/*
 *
 * User constants
 *
 */

export const FETCH_USER = 'app/User/FETCH_USER';
export const FETCH_USER_SUCCESS = 'app/User/FETCH_USER_SUCCESS';
export const FETCH_USER_SUCCESS_SEGMENT = 'app/User/FETCH_USER_SUCCESS_SEGMENT';
export const FETCH_USER_FAILED = 'app/User/FETCH_USER_FAILED';

export const USER_RESEARCHER = 'researcher';
export const USER_PUBLISHER = 'publisher';
export const USER_ADMIN = 'pollfish';

export const UserPerks = Object.freeze({
  abTest: 'abTest',
  accountManager: 'accountManager',
  advancedThemeSettings: 'advancedThemeSettingsPerk',
  allowSettingIrAndLoi: 'allowSettingIrAndLoi',
  bigQueryExport: 'bigQueryExport',
  conjointTest: 'conjointTest',
  crosstabDesigner: 'crosstabDesignerPerk',
  crunchExport: 'crunchExport',
  dLinkProdegePanelRedirects: 'dLinkProdegePanelRedirects',
  disqualificationRules: 'disqualificationRulesPerk',
  distributionLink: 'distributionLinkPerk',
  downloadSummary: 'downloadSummary',
  aiResultsReport: 'aiResultsReport',
  editSurveyTemplates: 'editSurveyTemplates',
  extraScreeningQuestions: 'extraScreeningQuestions',
  forDistributionLink: 'forDistributionLink',
  forPeeq: 'forPeeq',
  hide1617AgeRange: 'hide1617AgeRange',
  invoicePayments: 'invoicePayments',
  maxDiff: 'maxDiff',
  openEndedGrouping: 'openEndedGrouping',
  osVersion: 'osVersionPerk',
  peeqSurvey: 'peeqSurvey',
  pfThirdPartySurvey: 'pfThirdPartySurvey',
  regularSurvey: 'regularSurvey',
  residentialPostalCodeResults: 'residentialPostalCodeResults',
  residentialPostalCodes: 'residentialPostalCodes',
  respondentId: 'respondentId',
  scheduling: 'scheduling',
  screeningLimits: 'screeningLimits',
  screeningQuotas: 'screeningQuotas',
  screenoutExport: 'screenoutExport',
  surveyTheme: 'surveyThemePerk',
  teamAccount: 'teamAccount',
  translations: 'translations',
  useSurveyTemplates: 'useSurveyTemplates',
  vanWestendorpQuestion: 'vanWestendorpQuestion',
  whiteLabelling: 'whiteLabelling',
  hiddenVariable: 'hiddenVariables',
  questionnaireSimpleQuotas: 'questionnaireSimpleQuotas',
  questionnaireAdvancedQuotas: 'questionnaireAdvancedQuotas',
  questionnaireMinimumResponses: 'questionnaireMinimumResponses',
});

export const SHARED_RESOURCES = {
  CREDITS: 'credits',
  SUBSCRIPTIONS: 'subscription_plans',
};
